import { TextField } from "@mui/material";
import React, { useState, useEffect, useRef } from "react";

const InputArea = ({
  required,
  label,
  rowsMax,
  helperText,
  defaultValue,
  error,
  value,
  onChange,
  disabled,
  placeholder,
  maxLength,
  showLength,
  className,
  variant,
}) => {
  const [inputValue, setInputValue] = useState(value);
  const timeout = useRef(null);
  useEffect(() => {
    setInputValue(value);
  }, [value]);
  const changeHandler = (e) => {
    const value = e.target.value;
    setInputValue(value);
    if (timeout.current) {
      clearTimeout(timeout.current);
    }
    timeout.current = setTimeout(() => {
      onChange(value);
    }, 300);
  };
  return (
    <TextField
      disabled={disabled}
      required={required}
      placeholder={placeholder}
      error={error}
      label={label}
      multiline
      rowsmax={rowsMax || "10"}
      defaultValue={defaultValue}
      variant={variant}
      helperText={
        helperText
          ? helperText
          : showLength && !disabled
          ? `${inputValue ? inputValue.length : 0} ${maxLength ? `/${maxLength}` : ""}`
          : null
      }
      value={inputValue || ""}
      onChange={changeHandler}
      className={[className].join(" ")}
      margin="normal"
      inputProps={{ maxLength: maxLength ? maxLength : null }}
      FormHelperTextProps={{
        className: "text-right",
      }}
    />
  );
};

export default InputArea;
